<template>
  <vs-list v-if="show">
    <vs-list-item v-for="driver in deliverers" :key="driver.id">
      <template slot="title">
        <b>
          {{ getDelivererName(driver) }}
          <span class="float-right">{{ driver.age }}</span>
        </b>
      </template>
      <template slot="subtitle" v-if="shouldShowMetrics(driver)">
        <div>Tel: {{ driver.phone_number }}</div>
        <vs-icon icon="assignment" class="delivery-driver-list-icon"></vs-icon>
        {{ getJobs(driver) }} |
        <vs-icon :icon="getChargingIcon(driver)" class="delivery-driver-list-icon"></vs-icon>
        {{ getBatteryPercentage(driver) | percentage }}
        <vs-icon icon="network_check" class="delivery-driver-list-icon"></vs-icon>
        {{ getSpeed(driver) | km_hour }} |
      </template>
      <template slot="avatar">
        <div class="wrapper" @click="openDriverPopup(driver)">
          <vs-avatar size="large" :src="avatar(driver)" class="driver-icon"/>
        </div>
      </template>
    </vs-list-item>
  </vs-list>
</template>

<script>
export default {
  props: ['deliverers', 'show'],

  methods: {
    shouldShowMetrics(driver) {
      return (driver.office ? driver.active && !driver.office : driver.active);
    },
    getDelivererName(driver) {
      let insertion = driver.insertion == null ? "" : driver.insertion;
      return insertion !== "null" ? driver.firstname + ' ' + insertion + ' ' + driver.lastname : driver.firstname + ' ' + driver.lastname;
    },

    getChargingIcon(deliverer) {
      return deliverer.phone !== null ? (deliverer.phone.charging === '1' ? 'battery_charging_full' : 'battery_full') : 'battery_full';
    },

    getBatteryPercentage(deliverer) {
      return deliverer.phone !== null ? (deliverer.phone.battery < 0 ? 0 : deliverer.phone.battery) : 0;
    },

    avatar(deliverer) {
      return deliverer.image;
    },

    getSpeed(deliverer) {
      return deliverer.phone !== null ? deliverer.phone.speed : 0;
    },

    getOrders(deliverer) {
      return deliverer.jobs;
    },

    openDriverPopup(deliverer) {
      this.$events.fire('open-deliverer-modal', deliverer);
    },

    getJobs(deliverer) {
      return deliverer.jobs;
    },

    isActive(driver) {
      return driver.active;
    },

    isOffice(driver) {
      return driver.office;
    }

  }
};
</script>

<style>
.delivery-driver-list-icon {
  top: 2px;
  position: relative;
}
.driver-icon {
  margin-right: 15px;
}
</style>